<template>
  <div>
    <div class="viewport viewport-with-bottom-nav viewport-compact" ref="viewportContainer">
      <div class="display-1 my-3">{{ $t('BranchesPage.title') }}</div>
      <BranchesList detailsRoute="branch"></BranchesList>
      <div class="flex-grow-1"></div>
      <BottomNav></BottomNav>
    </div>
  </div>
</template>

<script>

import BranchesList from '@shared/components/BranchesList'
import BottomNav from '../components/BottomNav'

export default {
  name: 'BranchesPage',
  components: { BottomNav, BranchesList }
}
</script>
